module.exports = __webpack_public_path__ + "static/img/二维码2.0fc2f361.png";